import React, { useState, useContext } from "react";
import { Form, Table } from "react-bootstrap";

import Successfull_Modal from "../../../Common_modal/Successfull_Modal/Successfull_Modal";
import Common_Button from "../../../Common-Component/Common_Button/Common_Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useRazorpay from "react-razorpay";

import { useNavigate } from "react-router-dom";

import { Checkout } from "../../../../utils/apis/orderProcess/orderProcess";
import Cart from "../../Cart/Cart";
import { Context } from "../../../../utils/context";
import ScrollToTop from "../../../ScrollTotop/ScrollTotop";
import { useEffect } from "react";
import { PuffLoader } from "react-spinners";
import {
  getAllMultipleVariants,
  getAllSingleVariants,
} from "../../../../utils/apis/Product/Product";
import { getCart } from "../../../../utils/apis/addToCart/addToCart";

const ThreeOrder = ({ handlePrevious, paymentMethod, addressId }) => {

  const [modalShow, setModalShow] = useState(false);
  const [numberTwo, setNumberTwo] = useState(1);
  const [numbOne, setNumberOne] = useState(1);

  const navigate = useNavigate();

  const hideModalWithDelay = () => {
    setTimeout(() => {
      setModalShow(false);
      navigate("/");
    }, 3000);
  };

  const {
    Select2Data,
    setopen_delivery,
    open_delivery,
    userdata,
    setOutOfStock,
    outOfStock,
    triggerCartUpdate,
    membershipDiscount,
    setMembershipDiscount,
    quick_delivery,
    setquick_delivery,
    reactLoader,
    setReactLoader,
    setDiscount,
    discount,
    setDeliveryCharges,
    deliveryCharges,
  } = useContext(Context);

  //Payment Gateway

  const [Razorpay, openRazorpay] = useRazorpay();
  const [razorid, setRazorId] = useState();

  const [amount, setAmount] = useState();
  const [tax, setTotalTax] = useState();
  const [deliveryInstruction, setDeliveryInstruction] = useState();
  const [coupon, setCoupon] = useState("");
  const [adminAmount, setAdminAmount] = useState("");


  const [cart, setCart] = useState([]);
  const [singleVarient, setSingleVarient] = useState([]);
  const [multipleVarient, setMultipleVarient] = useState([]);

  const cartGet = async () => {
    const res = await getCart();
    if (res?.success) {
      setCart(res?.data);
    }
  };
  useEffect(() => {
    cartGet();
  }, []);

  const getSingleProducts = async () => {
    const res = await getAllSingleVariants();
    if (res?.success) {
      setSingleVarient(res?.data);
    }
  };

  useEffect(() => {
    getSingleProducts();
  }, []);

  const getMultipleProducts = async () => {
    const res = await getAllMultipleVariants();
    if (res?.success) {
      setMultipleVarient(res?.data);
    }
  };

  useEffect(() => {
    getMultipleProducts();
  }, []);

  const handleRazorpay = async (storedValue) => {
    const isInvalid = cart.some((c) => {
      // Find the single variant unit
      const singleUnit = singleVarient.find((s) => s.id === c.variant_id)?.unit;

      // Find the multiple variant unit
      const multipleUnit = multipleVarient.find((m) => m.id === c.m_variant_id)
        ?.unit;

      // Compare the quantity with the respective unit
      if (singleUnit !== undefined && Number(c.quantity) > Number(singleUnit)) {
        return true;
      }

      if (
        multipleUnit !== undefined &&
        Number(c.quantity) > Number(multipleUnit)
      ) {
       
        return true;
      }

      return false; // No issues found
    });

    if (isInvalid) {
      alert("One or more items in your cart exceed the available stock.");
      return;
    }
    const options: RazorpayOptions = {
      key: "rzp_test_I05KCFb1v5JJRc",
      amount: Math.round(storedValue) * 100,
      currency: "INR",
      name: "Boomerbuckz",
      description: "Test Transaction",
      image:
        "http://localhost:3000/static/media/hippicart-logo.427718645d3015dbf003.png",

      handler: async (res) => {
        await setRazorId(res.razorpay_payment_id);
        finalFunction(res.razorpay_payment_id);
      },
      prefill: {
        name: "Piyush Garg",
        email: "youremail@example.com",
        contact: "9999999999",
      },
      notes: {
        address: "Razorpay Corporate Office",
      },
      theme: {
        color: "#052c65",
      },
    };

    const rzpay = new Razorpay(options);
    rzpay.open();
  };

  const finalFunction = async (razor = null) => {
    const isInvalid = cart.some((c) => {
      const singleUnit = singleVarient.find((s) => s.id === c.variant_id)?.unit;

      const multipleUnit = multipleVarient.find((m) => m.id === c.m_variant_id)
        ?.unit;

      if (singleUnit !== undefined && Number(c.quantity) > Number(singleUnit)) {
        return true;
      }

      if (
        multipleUnit !== undefined &&
        Number(c.quantity) > Number(multipleUnit)
      ) {
      
        return true;
      }

      return false;
    });

    if (isInvalid) {
      alert("One or more items in your cart exceed the available stock.");
      return;
    }

    const data = {
      address_id: addressId,
      amount: Number(amount),
      discount: Number(discount),
      // admin_amount: Number(adminAmount),
      tax: tax,
      open_delivery: open_delivery,
      quick_delivery: quick_delivery || 0,
      delivery_charges: Number(deliveryCharges),
      delivery_instruction: deliveryInstruction,
      payment_mode: paymentMethod,
      transaction_id: razorid,
      payment_status:
        paymentMethod == "Wallet" || paymentMethod == "Online" ? 1 : 0,
    };

    // Add code_id if a coupon is applied
    if (coupon) {
      data.code_id = coupon;
    }

    // Check payment method and handle accordingly
    if (paymentMethod === "Wallet") {
      if (userdata.wallet_amount < amount) {
        alert("Wallet amount is low");
        return;
      }

      data.payment_id = 1;
    } else if (razor) {
      data.payment_id = razor;
    }

    try {
      setReactLoader(true);
      // Proceed with the checkout process
      const response = await Checkout(data);

      if (response?.success) {
        setModalShow(true);
        hideModalWithDelay();
        setopen_delivery(0);
        setquick_delivery(0);
        triggerCartUpdate();
        setTimeout(() => {
          setReactLoader(false);
        }, 2000);
        setMembershipDiscount(0);
      } else {
        await { code: response?.code, message: response?.message };
        setOutOfStock(response?.message);
      }
    } catch (error) {
      setReactLoader(false);
      console.error("An error occurred during checkout:", error);
      alert("An unexpected error occurred. Please try again later.");
    }
  };
  useEffect(() => {
    setOutOfStock("");
  }, []);

  return (
    <>
      <ScrollToTop />
      <div className="corfirm-order-holder">
        <section className="checkout-inner-steps">
          <div className="container">
            <div className="confirm_order Product_Cart threeorder">
              <Cart
                type={"checkout"}
                amount={amount}
                setAmount={setAmount}
                discount={discount}
                setDiscount={setDiscount}
                membershipDiscount={membershipDiscount}
                setMembershipDiscount={setMembershipDiscount}
                coupon={coupon}
                setCoupon={setCoupon}
                tax={tax}
                setTotalTax={setTotalTax}
                setDeliveryInstruction={setDeliveryInstruction}
                setAdminAmount={setAdminAmount}
                adminAmount={adminAmount}
              />
            </div>
            <div className="out_of_stock_text"> {outOfStock}</div>

            <div className="main-btn-div ">
              <Common_Button
                onClick={handlePrevious}
                text="Back"
                className=" back-btn"
              />

              {reactLoader ? (
                <div className="loder_holder">
                  <PuffLoader />
                </div>
              ) : paymentMethod === "Wallet" || paymentMethod === "COD" ? (
                <Common_Button
                  onClick={() => finalFunction()}
                  type="button"
                  disabled={reactLoader}
                  text="Confirm Order"
                  className="save-btn"
                />
              ) : (
                <Common_Button
                  onClick={() => handleRazorpay(amount)}
                  text="Confirm Order"
                  className="save-btn"
                />
              )}
            </div>
            
          </div>
        </section>
      </div>

      <Successfull_Modal
        message=" Your order has been placed successfully "
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
};

export default ThreeOrder;
